import React from 'react';
import { Box, SxProps, Typography } from '@mui/material';
import { useL2DTheme } from '@europrocurement/flexy-components';
import { PeoplePreview } from '../../liste';

export type ContactChipProps = {
    firstName: string;
    lastName: string;
    sx?: SxProps;
    tooltipTitle?: string;
};

const ContactChip: React.FunctionComponent<ContactChipProps> = function (props) {
    const { firstName, lastName, sx, tooltipTitle } = props;
    const { palette } = useL2DTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                gap: '0 8px',
                alignItems: 'center',
                backgroundColor: palette.chip.primary?.backgroundColor,
                borderRadius: '12px',
                padding: '2px 8px',
                color: palette.chip?.primary?.textColor,
                ...sx,
            }}
        >
            <PeoplePreview
                firstName={firstName}
                lastName={lastName}
                sx={{
                    borderRadius: '8px',
                    width: '16px',
                    height: '16px',
                    margin: '0',
                    borderWidth: '2px',
                    borderStyle: 'solid',
                    borderColor: 'background.paper',
                }}
                sxAvatar={{ width: '20px', height: '20px' }}
                tooltipTitle={tooltipTitle}
            />
            <Typography>
                {firstName} {lastName}
            </Typography>
        </Box>
    );
};

export default ContactChip;
